(function () {
  'use strict';

  var container = document.querySelector('[data-store-availability-container]');
  if (!container) return;

  var SECTION_ID = 'pickup-availability';
  var lastOpenTrigger = null;

  // -- Fetch & inject section content ----------------------------------------
  function fetchAvailability(variantId) {
    var productUrl = container.dataset.productUrl || window.location.pathname;
    var url = productUrl + '?variant=' + variantId + '&section_id=' + SECTION_ID;

    fetch(url)
      .then(function (res) {
        if (!res.ok) return Promise.reject(res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('.shopify-section');
        container.innerHTML = section ? section.innerHTML : '';
        hydrateModal();
      })
      .catch(function () {
        container.innerHTML = '';
      });
  }

  // -- Hydrate modal with product-level data (not available in section Liquid) -
  function hydrateModal() {
    var productTitleEl = container.querySelector('[data-pa-product-title]');
    if (productTitleEl) {
      productTitleEl.textContent = container.dataset.productTitle || '';
    }

    var variantTitleEl = container.querySelector('[data-pa-variant-title]');
    if (variantTitleEl && container.dataset.hasOnlyDefaultVariant === 'true') {
      variantTitleEl.hidden = true;
    }
  }

  // -- Modal helpers ----------------------------------------------------------
  function getModal() {
    return container.querySelector('.pa-modal');
  }

  function openModal(trigger) {
    var modal = getModal();
    if (!modal) return;
    lastOpenTrigger = trigger || null;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    // Double RAF ensures the browser has painted before starting the transition
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
        var closeBtn = modal.querySelector('.pa-modal__close');
        if (closeBtn) closeBtn.focus();
      });
    });
  }

  function closeModal() {
    var modal = getModal();
    if (!modal) return;
    if (lastOpenTrigger) {
      lastOpenTrigger.focus();
      lastOpenTrigger = null;
    }
    modal.classList.remove('is-open');
    var panel = modal.querySelector('.pa-modal__panel');
    if (panel) {
      panel.addEventListener('transitionend', function handler(e) {
        if (e.propertyName !== 'transform') return;
        panel.removeEventListener('transitionend', handler);
        modal.hidden = true;
        document.body.style.overflow = '';
      });
    } else {
      modal.hidden = true;
      document.body.style.overflow = '';
    }
  }

  // -- Event delegation - click -----------------------------------------------
  container.addEventListener('click', function (e) {
    var openEl = e.target.closest('[data-pa-modal-open]');
    var closeEl = e.target.closest('[data-pa-modal-close]');
    if (openEl) {
      openModal(openEl);
    } else if (closeEl) {
      closeModal();
    }
  });

  // -- Escape key ------------------------------------------------------------
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var modal = getModal();
    if (modal && !modal.hidden) closeModal();
  });

  // -- Focus trap ------------------------------------------------------------
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var modal = getModal();
    if (!modal || modal.hidden) return;

    var focusable = Array.from(modal.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    ));

    if (!focusable.length) { e.preventDefault(); return; }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  // -- Initial load ----------------------------------------------------------
  var initialVariantId = container.dataset.initialVariant;
  if (initialVariantId) fetchAvailability(initialVariantId);

  // -- Variant change listener (dispatched by product.liquid {% javascript %}) -
  document.addEventListener('pd:pickup-update', function (e) {
    if (e.detail && e.detail.variantId) fetchAvailability(e.detail.variantId);
  });

})();
